import firebase from "firebase";

export function prettyPrint(str, strCase ){
	if( !str ){ return "" }
	str = str.split("_").join(" ");
	str = str.split("-").join(" ");
	switch (strCase){
		case "TITLE":
			var sentence = str.toLowerCase().split(" ");
			for(var i = 0; i< sentence.length; i++){
				sentence[i] = sentence[i][0].toUpperCase() + sentence[i].slice(1);
			}
			return sentence.join(" ");
		case "SENTENCE":
			str = str.toLowerCase();
			str = str[0].toUpperCase() + str.slice(1);
			return str;
		case "LOWER":
			return str.toLowerCase();
		case "UPPER":
			return str.toUpperCase();
		default:
			return str;
	}
}

export function statusColor(status){
	switch(status){
		case "Confirmed":
		case "Complete":
			return "green";
		case "Cancelled":
			return "red";
		default:
			return "primary";
	}
}

export function sortByKey(array, key) {
    return array.sort(function(a, b) {
        var x = a[key]; var y = b[key];
        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
    });
}

export function formatDateTime(date, time){
	let theDate = new Date();
	if( date ){
		theDate = new Date(date + " 00:00:00");
	}
	if( time ){
		theDate.setHours(time.split(":").map( n => { return parseInt(n) } )[0])
		theDate.setMinutes(time.split(":").map( n => { return parseInt(n) } )[1])
	}
	let dateTime = firebase.firestore.Timestamp.fromDate(theDate);
	if( dateTime ){
		return dateTime;
	}
	else{
		return false;
	}
}
export function deduplicate(obj){
	let db = firebase.firestore();
	return db.collection("users").where("email", "==", obj.email ).get().then( function(snapshot){
		if( !snapshot.docs.length ){
			return { 
				unique: true
			}
		}
		else{
			return { 
				unique: false,
				key: "email"
			}
		}
	} ).then( is => {
		if( is.unique ){
			return db.collection("users").where("phone", "==", obj.phone ).get().then( function(snapshot){
				if( !snapshot.docs.length ){
					return { 
						unique: true
					}
				}
				else{
					return { 
						unique: false,
						key: "phone"
					}
				}

			} )
		}
		else{
			return is
		}
	} ).then( is => {
		if( is.unique ){
			return db.collection("users").where("displayName", "==", obj.name ).get().then( function(snapshot){
				if( !snapshot.docs.length ){
					return { 
						unique: true
					}
				}
				else{
					return { 
						unique: false,
						key: "name"
					}
				}

			} )
		}
		else{
			return is
		}
	} )
} 
// 
import FileSaver from "file-saver";
import icsFormatter from "../assets/icsFormatter.js";
export function exportCalendar(events, calendarName, optionalLocation=""){
	var calEntry = icsFormatter();
	events.forEach( function(event){		
		var start = new Date(event.start);
		var end;
		if( event.end ){
			end = new Date(event.end);
		}
		else{
			end = new Date(start.getTime() + 60*60000);
		}
		if( !event.location ){
			event.location = optionalLocation;
		}
		let description = "";
		if( event.appointment ){
			description = window.location.origin + "/appointments/view/" + event.appointment;
		}
		calEntry.addEvent(event.name, description, event.location, start.toUTCString(), end.toUTCString());
	})
	var blob = new Blob([calEntry.download()], {type: "text/calendar;charset=utf8"});
	FileSaver.saveAs(blob, calendarName + ".ics");

}

